var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"categroy-nav-view root-box",class:{ showNavBar: _vm.showNavBar }},[_c('search-item',{attrs:{"pageId":_vm.pageId}}),_c('div',{staticClass:"container"},[_c('nav-item',{attrs:{"pageId":_vm.pageId}}),_c('category-right',{attrs:{"pageId":_vm.pageId}})],1),_c('share-sheet-box')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }